export const allowedFileExtensions = {
  document: ['ppt', 'pptx', 'doc', 'docx', 'pdf', 'xls', 'xlsm', 'xlsx', 'zip'],
  media: [
    'mp3',
    'm4v',
    'mp4',
    'ogv',
    '3gp',
    'avi',
    'webm',
    'mov',
    'flv',
    'wmv'
  ],
  image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
}

export default allowedFileExtensions
